let hashedEmail: string | null = null

export function setAnalyticsHashedEmail(hash: string | null): void {
  hashedEmail = hash || null
}

export function getAnalyticsHashedEmail(): string | null {
  return hashedEmail
}
